module.exports = __webpack_public_path__ + "92ecc3226bf1efc37408dd512399dd1c.glb";